if (window.boostSDAppConfig) {
    window.boostSDAppConfig.integration = Object.assign({
        wishlists: 'king'
    }, window.boostSDAppConfig.integration || {});
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        /* Start-Boost-231499 */
        componentRegistry.useComponentPlugin('ProductSwatch', {
            name: 'ProductSwatch component',
            apply: () => ({
                afterRender: (element) => {
                    try {
                        const productData = element.getParentElm().getParams().props.data;
                        const props = element.getParams().props;
                        
                        if (productData && props?.options) {
                            for (let i = 0; i < props.options.length; i++) {
                                const option = props.options[i];
                                const optionTitle = option.labelAs;
                                const swatchValue = option.value;

                                let foundVariant = '';
                                for (let j = 0; j < productData.variants.length; j++) {
                                    const variant = productData.variants[i];
                                    const foundOption = variant.original_merged_options.filter(function(e) {
                                        return e === optionTitle + ':' + swatchValue;
                                    })
                                    if (typeof foundOption[0] !== 'undefined') {
                                        foundVariant = variant;
                                        break;
                                    }
                                }
                                if (foundVariant !== '') {
                                    const variantId = foundVariant.id;
                                    const variantMeta = productData.metafields.filter(function(e) {
                                        return e.namespace == 'color_name' && e.key == 'color' && e?.id == variantId;
                                    })
                                    if (typeof variantMeta[0] !== 'undefined') {
                                        const variantMetaValue = variantMeta[0]['value'];
                                      
                                        const swatchElm = document.querySelectorAll('.boost-sd__product-item .boost-sd__product-swatch input[id^="product-swatch-"]');
                                        if (swatchElm) {
                                            Array.from(swatchElm).forEach(swatch => {
                                                const swatchText = swatch.getAttribute('value');
                                                const siblingElm = swatch.previousElementSibling;
                                                if (swatchText == swatchValue) {
                                                    siblingElm.innerText = variantMetaValue;
                                                }
                                            });
                                        }
                                    }
                                }
                            }
                        }
                    } catch (e) {
                        console.warn(e);
                    }
                },
            }),
        });
        /* End-Boost-231499 */
    }
]);